let loaded = null;

export default function loadMediaFeatures() {
  if (loaded !== null) return loaded;

  loaded = new Promise(resolve => {
    window.Shopify.loadFeatures(
      [
        {
          name: "model-viewer-ui",
          version: "1.0",
        },
        {
          name: "shopify-xr",
          version: "1.0",
        },
        {
          name: "video-ui",
          version: "1.0",
        },
      ],
      () => {
        if ("YT" in window && Boolean(YT.loaded)) {
          resolve();
        } else {
          window.onYouTubeIframeAPIReady = function () {
            resolve();
          };
        }
      }
    );
  });

  return loaded;
}
